export const translations = {
  ru: {
    // Common
    loading: 'Загрузка...',
    save: 'Сохранить',
    cancel: 'Отмена',
    delete: 'Удалить',
    confirm: 'Подтвердить',
    close: 'Закрыть',
    edit: 'Редактировать',
    add: 'Добавить',
    search: 'Поиск',
    filter: 'Фильтр',
    logout: 'Выйти',
    login: 'Войти',
    register: 'Регистрация',
    email: 'Email',
    name: 'Имя',
    password: 'Пароль',
    status: 'Статус',
    actions: 'Действия',
    date: 'Дата',
    amount: 'Сумма',
    currency: 'Валюта',
    type: 'Тип',
    label: 'Метка',
    details: 'Детали',
    back: 'Назад',
    next: 'Далее',
    download: 'Скачать',
    
    // Landing Page
    landing: {
      title: 'Платформа Массовых Выплат',
      subtitle: 'Безопасная, прозрачная и автоматизированная система распределения выплат для управления крупномасштабными финансовыми обязательствами.',
      getStarted: 'Начать',
      login: 'Войти',
      features: {
        title: 'Ключевые Преимущества',
        secure: {
          title: 'Безопасно',
          desc: 'Все транзакции логируются и проверяются. Полная прозрачность в распределении выплат.'
        },
        convenient: {
          title: 'Удобно',
          desc: 'Автоматизированное равное распределение между всеми активными пользователями с точными расчётами.'
        },
        transparent: {
          title: 'Прозрачно',
          desc: 'Автоматическое управление резервным фондом с детальной отчётностью и аудитом.'
        }
      },
      footer: '© 2025 MassPayHub. Безопасная Платформа Распределения Выплат.'
    },
    
    // Auth
    auth: {
      welcomeBack: 'Добро Пожаловать',
      registerTitle: 'Регистрация',
      registerSubtitle: 'Создайте свой аккаунт',
      emailPlaceholder: 'your@email.com',
      namePlaceholder: 'Иван Иванов',
      enterEmail: 'Введите email для получения кода входа',
      enterCode: 'Введите код, отправленный на ваш email',
      sendCode: 'Отправить код',
      verifyLogin: 'Подтвердить и войти',
      sending: 'Отправка...',
      verifying: 'Проверка...',
      registering: 'Регистрация...',
      codeSent: 'Отправлено на',
      changeEmail: 'Изменить Email',
      backToHome: 'На главную',
      alreadyHaveAccount: 'Уже есть аккаунт? Войти',
      termsTitle: 'Условия Использования',
      acceptTerms: 'Я принимаю условия использования для получения выплат',
      pleaseAcceptTerms: 'Пожалуйста, примите условия использования',
      registrationSuccess: 'Регистрация успешна! Пожалуйста, дождитесь одобрения администратора.',
      otpSent: 'OTP код отправлен на ваш email!',
      loginSuccess: 'Вход выполнен!',
      oneTimePassword: 'Одноразовый Пароль'
    },
    
    // User Dashboard
    user: {
      dashboard: 'Личный Кабинет',
      overview: 'Обзор',
      credentials: 'Платёжные Реквизиты',
      history: 'История Выплат',
      notifications: 'Уведомления',
      accountStatus: 'Статус Аккаунта',
      statusActive: 'Ваш аккаунт активен и готов к получению выплат',
      statusPending: 'Ваш аккаунт ожидает одобрения администратора',
      statusBlocked: 'Ваш аккаунт заблокирован. Обратитесь в поддержку.',
      account: 'Счёт',
      totalPayments: 'Всего Получено',
      lastPayment: 'Последняя Выплата',
      addCredential: 'Добавить Реквизит',
      newCredential: 'Новый Реквизит',
      credentialType: 'Тип Реквизита',
      credentialDetails: 'Детали (Адрес кошелька или банковские данные)',
      credentialLabel: 'Метка (необязательно)',
      labelPlaceholder: 'Например, Основной Кошелёк',
      saveCredential: 'Сохранить Реквизит',
      noCredentials: 'Реквизиты для выплат ещё не добавлены',
      primary: 'Основной',
      setPrimary: 'Сделать основным',
      noPayments: 'История выплат пока пуста',
      noNotifications: 'Нет уведомлений',
      paymentScheduled: 'Новая Выплата Запланирована',
      paymentSent: 'Выплата Отправлена',
      accountApproved: 'Аккаунт Одобрен',
      pending: 'в ожидании',
      completed: 'завершено',
      active: 'активен',
      blocked: 'заблокирован'
    },
    
    // Admin Dashboard
    admin: {
      panel: 'Админ Панель',
      statistics: 'Статистика',
      users: 'Управление Пользователями',
      distribute: 'Распределить Средства',
      paymentQueue: 'Очередь Выплат',
      reserveFund: 'Резервный Фонд',
      reports: 'Отчёты',
      settings: 'Настройки',
      platformStats: 'Статистика Платформы',
      totalUsers: 'Всего Пользователей',
      activeUsers: 'Активные Пользователи',
      pendingApproval: 'Ожидают Одобрения',
      totalDistributed: 'Всего Распределено',
      lastDistribution: 'Последнее Распределение',
      reserveFundBalance: 'Баланс Резервного Фонда',
      averagePayment: 'Средняя Выплата',
      totalAllAccounts: 'Всего на Всех Счетах',
      totalAccount1: 'Всего на Счете-1',
      totalAccount2: 'Всего на Счете-2',
      account1: 'Счет-1',
      account2: 'Счет-2',
      block: 'Заблокировать',
      unblock: 'Разблокировать',
      viewDetails: 'Подробнее',
      accounts: 'Счета',
      editAccounts: 'Редактировать счета',
      accountNumber: 'Номер счета',
      paymentCredentials: 'Платежные реквизиты',
      primary: 'Основной',
      noLabel: 'Без метки',
      userStatistics: 'Статистика пользователя',
      totalReceived: 'Получено всего',
      pendingAmount: 'Ожидает выплаты',
      recentPayments: 'Последние платежи',
      registeredDate: 'Дата регистрации',
      accountsUpdated: 'Счета обновлены',
      reservePercent: 'Процент резервного фонда',
      reservePercentHint: 'По умолчанию 10%. Можно изменить от 0 до 100%',
      customDistribution: 'Ручное распределение',
      individualPaymentAmount: 'Сумма на одного пользователя',
      enterIndividualAmount: 'Введите сумму на пользователя',
      individualAmountHint: 'Остаток автоматически пойдет в резервный фонд',
      recipients: 'получателей',
      reserveAllocation: 'В резервный фонд',
      currentReserve: 'Текущий резерв',
      newReserveTotal: 'Новый итог резерва',
      customDistributionWarning: 'Используется ручное распределение. Проверьте расчеты!',
      individualPayments: 'Индивидуальные выплаты по пользователям',
      clickToEdit: 'Кликните для редактирования',
      paymentAmount: 'Сумма выплаты',
      totalDistribution: 'Итого к распределению',
      editIndividualHint: 'Вы можете изменить сумму для каждого пользователя индивидуально. Итоги пересчитаются автоматически.',
      approveUser: 'Одобрить Пользователя',
      account1Balance: 'Баланс Счёта 1',
      account1Currency: 'Валюта Счёта 1',
      account2Balance: 'Баланс Счёта 2',
      account2Currency: 'Валюта Счёта 2',
      selectCurrency: 'Выберите валюту',
      approve: 'Одобрить',
      block: 'Заблокировать',
      unblock: 'Разблокировать',
      userApproved: 'Пользователь одобрен успешно',
      userBlocked: 'Статус пользователя изменён',
      distributeFunds: 'Распределение Средств',
      calculator: 'Калькулятор Распределения',
      totalAmount: 'Общая Сумма',
      enterAmount: 'Введите сумму для распределения',
      sourceAccount: 'Счёт Источник',
      account1: 'Счёт 1',
      account2: 'Счёт 2',
      sourceAccountHint: 'Выберите счёт, с которого будет произведена выплата',
      autoAccountSelection: 'Автоматический выбор счёта',
      autoAccountHint: 'Система автоматически использует Счёт 1 (возврат инвестиций) пока не опустошены все Счета-1. Затем переключается на Счёт 2 (прибыль).',
      calculate: 'Рассчитать Распределение',
      preview: 'Предпросмотр Распределения',
      individualPayment: 'Индивидуальная Выплата',
      totalToUsers: 'Всего Пользователям',
      reserveAllocation: 'Выделение в Резерв',
      confirmDistribution: 'Подтвердить Распределение',
      processing: 'Обработка...',
      distributionSuccess: 'Сумма распределена успешно!',
      noActiveUsers: 'Нет активных пользователей для распределения',
      queue: 'Очередь Выплат',
      allPayments: 'Все Выплаты',
      user: 'Пользователь',
      credentials: 'Реквизиты',
      noCredentials: 'Нет реквизитов',
      confirmSent: 'Подтвердить Отправку',
      paymentConfirmed: 'Выплата подтверждена и пользователь уведомлён',
      noPaymentsInQueue: 'Нет выплат в очереди',
      viewDetails: 'Просмотр',
      paymentDetails: 'Детали Выплаты',
      userInformation: 'Информация о Пользователе',
      paymentInformation: 'Информация о Выплате',
      paymentCredentials: 'Реквизиты для Выплаты',
      userId: 'ID Пользователя',
      createdAt: 'Создано',
      confirmedAt: 'Подтверждено',
      beneficiaryName: 'Получатель',
      bankName: 'Название Банка',
      walletAddress: 'Адрес Кошелька',
      currentBalance: 'Текущий Баланс',
      distributeReserve: 'Распределить из Резерва',
      amountToDistribute: 'Сумма для распределения',
      transactionHistory: 'История Транзакций',
      noTransactions: 'Транзакций пока нет',
      distributionReports: 'Отчёты о Распределениях',
      noReports: 'Отчёты ещё не сгенерированы',
      downloadPDF: 'Скачать PDF',
      reportDownloaded: 'Отчёт скачан',
      platformSettings: 'Настройки Платформы',
      termsAndConditions: 'Условия Использования',
      termsDescription: 'Редактируйте условия использования, которые пользователи должны принять при регистрации.',
      saving: 'Сохранение...',
      saveChanges: 'Сохранить Изменения',
      termsUpdated: 'Условия использования обновлены успешно',
      totalPayments: 'Всего Выплат'
    },
    
    // Toasts & Messages
    messages: {
      success: 'Успешно',
      error: 'Ошибка',
      warning: 'Внимание',
      info: 'Информация',
      confirmDelete: 'Вы уверены, что хотите удалить это?',
      credentialAdded: 'Реквизит успешно добавлен',
      credentialDeleted: 'Реквизит удалён',
      primaryUpdated: 'Основной реквизит обновлён',
      failedToLoad: 'Не удалось загрузить',
      invalidAmount: 'Пожалуйста, введите корректную сумму',
      insufficientBalance: 'Недостаточно средств'
    }
  },
  
  en: {
    // Common
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    confirm: 'Confirm',
    close: 'Close',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    filter: 'Filter',
    logout: 'Logout',
    login: 'Login',
    register: 'Register',
    email: 'Email',
    name: 'Name',
    password: 'Password',
    status: 'Status',
    actions: 'Actions',
    date: 'Date',
    amount: 'Amount',
    currency: 'Currency',
    type: 'Type',
    label: 'Label',
    details: 'Details',
    back: 'Back',
    next: 'Next',
    download: 'Download',
    
    // Landing Page
    landing: {
      title: 'Mass Payment Distribution Platform',
      subtitle: 'Secure, transparent, and automated payment distribution system for managing large-scale financial obligations.',
      getStarted: 'Get Started',
      login: 'Login',
      features: {
        title: 'Key Features',
        secure: {
          title: 'Secure',
          desc: 'All transactions are logged and auditable. Complete transparency in payment distribution.'
        },
        convenient: {
          title: 'Convenient',
          desc: 'Automated equal distribution among all active users with precise calculations.'
        },
        transparent: {
          title: 'Transparent',
          desc: 'Automatic reserve fund management with detailed reporting and audit trails.'
        }
      },
      footer: '© 2025 MassPayHub. Secure Payment Distribution Platform.'
    },
    
    // Auth
    auth: {
      welcomeBack: 'Welcome Back',
      registerTitle: 'Register',
      registerSubtitle: 'Create your account',
      emailPlaceholder: 'your@email.com',
      namePlaceholder: 'John Doe',
      enterEmail: 'Enter your email to receive login code',
      enterCode: 'Enter the code sent to your email',
      sendCode: 'Send Login Code',
      verifyLogin: 'Verify & Login',
      sending: 'Sending...',
      verifying: 'Verifying...',
      registering: 'Registering...',
      codeSent: 'Sent to',
      changeEmail: 'Change Email',
      backToHome: 'Back to Home',
      alreadyHaveAccount: 'Already have an account? Login',
      termsTitle: 'Terms and Conditions',
      acceptTerms: 'I accept the terms and conditions for receiving payments',
      pleaseAcceptTerms: 'Please accept the terms and conditions',
      registrationSuccess: 'Registration successful! Please wait for admin approval.',
      otpSent: 'OTP sent to your email!',
      loginSuccess: 'Login successful!',
      oneTimePassword: 'One-Time Password'
    },
    
    // User Dashboard
    user: {
      dashboard: 'User Dashboard',
      overview: 'Overview',
      credentials: 'Payment Credentials',
      history: 'Payment History',
      notifications: 'Notifications',
      accountStatus: 'Account Status',
      statusActive: 'Your account is active and ready to receive payments',
      statusPending: 'Your account is pending admin approval',
      statusBlocked: 'Your account has been blocked. Contact support.',
      account: 'Account',
      totalPayments: 'Total Payments Received',
      lastPayment: 'Last Payment Amount',
      addCredential: 'Add Credential',
      newCredential: 'Add New Credential',
      credentialType: 'Credential Type',
      credentialDetails: 'Details (Wallet Address or Bank Info)',
      credentialLabel: 'Label (Optional)',
      labelPlaceholder: 'e.g., Main Wallet',
      saveCredential: 'Save Credential',
      noCredentials: 'No payment credentials added yet',
      primary: 'Primary',
      setPrimary: 'Set as Primary',
      noPayments: 'No payment history yet',
      noNotifications: 'No notifications',
      paymentScheduled: 'New Payment Scheduled',
      paymentSent: 'Payment Sent',
      accountApproved: 'Account Approved',
      pending: 'pending',
      completed: 'completed',
      active: 'active',
      blocked: 'blocked'
    },
    
    // Admin Dashboard
    admin: {
      panel: 'Admin Panel',
      statistics: 'Statistics',
      users: 'Users Management',
      distribute: 'Distribute Funds',
      paymentQueue: 'Payment Queue',
      reserveFund: 'Reserve Fund',
      reports: 'Reports',
      settings: 'Settings',
      platformStats: 'Platform Statistics',
      totalUsers: 'Total Users',
      activeUsers: 'Active Users',
      pendingApproval: 'Pending Approval',
      totalDistributed: 'Total Distributed',
      lastDistribution: 'Last Distribution',
      reserveFundBalance: 'Reserve Fund',
      averagePayment: 'Average Payment',
      totalAllAccounts: 'Total All Accounts',
      totalAccount1: 'Total Account 1',
      totalAccount2: 'Total Account 2',
      account1: 'Account 1',
      account2: 'Account 2',
      block: 'Block',
      unblock: 'Unblock',
      viewDetails: 'View Details',
      accounts: 'Accounts',
      editAccounts: 'Edit Accounts',
      accountNumber: 'Account Number',
      paymentCredentials: 'Payment Credentials',
      primary: 'Primary',
      noLabel: 'No Label',
      userStatistics: 'User Statistics',
      totalReceived: 'Total Received',
      pendingAmount: 'Pending Amount',
      recentPayments: 'Recent Payments',
      registeredDate: 'Registration Date',
      accountsUpdated: 'Accounts Updated',
      reservePercent: 'Reserve Fund Percent',
      reservePercentHint: 'Default 10%. Can be changed from 0 to 100%',
      customDistribution: 'Manual Distribution',
      individualPaymentAmount: 'Amount per User',
      enterIndividualAmount: 'Enter amount per user',
      individualAmountHint: 'Remainder will automatically go to reserve fund',
      recipients: 'recipients',
      reserveAllocation: 'To Reserve Fund',
      currentReserve: 'Current Reserve',
      newReserveTotal: 'New Reserve Total',
      customDistributionWarning: 'Using manual distribution. Check calculations!',
      approveUser: 'Approve User',
      account1Balance: 'Account 1 Balance',
      account1Currency: 'Account 1 Currency',
      account2Balance: 'Account 2 Balance',
      account2Currency: 'Account 2 Currency',
      selectCurrency: 'Select currency',
      approve: 'Approve',
      block: 'Block',
      unblock: 'Unblock',
      userApproved: 'User approved successfully',
      userBlocked: 'User status updated',
      distributeFunds: 'Distribute Funds',
      calculator: 'Distribution Calculator',
      totalAmount: 'Total Amount',
      enterAmount: 'Enter amount to distribute',
      sourceAccount: 'Source Account',
      account1: 'Account 1',
      account2: 'Account 2',
      sourceAccountHint: 'Select account from which payment will be made',
      autoAccountSelection: 'Automatic Account Selection',
      autoAccountHint: 'System automatically uses Account 1 (investment return) until all Account-1 are empty. Then switches to Account 2 (profit).',
      calculate: 'Calculate Distribution',
      preview: 'Distribution Preview',
      individualPayment: 'Individual Payment',
      totalToUsers: 'Total to Users',
      reserveAllocation: 'Reserve Fund Allocation',
      confirmDistribution: 'Confirm Distribution',
      processing: 'Processing...',
      distributionSuccess: 'Amount distributed successfully!',
      noActiveUsers: 'No active users to distribute to',
      queue: 'Payment Queue',
      allPayments: 'All Payments',
      user: 'User',
      credentials: 'Credentials',
      noCredentials: 'No credentials',
      confirmSent: 'Confirm Sent',
      paymentConfirmed: 'Payment confirmed and user notified',
      noPaymentsInQueue: 'No payments in queue',
      viewDetails: 'View Details',
      paymentDetails: 'Payment Details',
      userInformation: 'User Information',
      paymentInformation: 'Payment Information',
      paymentCredentials: 'Payment Credentials',
      userId: 'User ID',
      createdAt: 'Created At',
      confirmedAt: 'Confirmed At',
      beneficiaryName: 'Beneficiary',
      bankName: 'Bank Name',
      walletAddress: 'Wallet Address',
      currentBalance: 'Current Balance',
      distributeReserve: 'Distribute from Reserve',
      amountToDistribute: 'Amount to distribute',
      transactionHistory: 'Transaction History',
      noTransactions: 'No transactions yet',
      distributionReports: 'Distribution Reports',
      noReports: 'No reports generated yet',
      downloadPDF: 'Download PDF',
      reportDownloaded: 'Report downloaded',
      platformSettings: 'Platform Settings',
      termsAndConditions: 'Terms and Conditions',
      termsDescription: 'Edit the terms and conditions that users must accept during registration.',
      saving: 'Saving...',
      saveChanges: 'Save Changes',
      termsUpdated: 'Terms updated successfully',
      totalPayments: 'Total Payments'
    },
    
    // Toasts & Messages
    messages: {
      success: 'Success',
      error: 'Error',
      warning: 'Warning',
      info: 'Info',
      confirmDelete: 'Are you sure you want to delete this?',
      credentialAdded: 'Credential added successfully',
      credentialDeleted: 'Credential deleted',
      primaryUpdated: 'Primary credential updated',
      failedToLoad: 'Failed to load',
      invalidAmount: 'Please enter a valid amount',
      insufficientBalance: 'Insufficient balance'
    }
  }
};

export const getTranslation = (lang, key) => {
  const keys = key.split('.');
  let value = translations[lang];
  
  for (const k of keys) {
    if (value && typeof value === 'object') {
      value = value[k];
    } else {
      return key;
    }
  }
  
  return value || key;
};
